<script setup>
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data.background_color}` : '',
      data?.spacing?.top
        ? `section--top-${data.spacing.top}`
        : 'section--top-xl',
      data?.spacing?.bottom
        ? `section--bottom-${data.spacing.bottom}`
        : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div class="bus-models">
        <h2
          v-if="data.title && data.title.length > 0"
          :class="[
            'mb-0 h2 bus-models__title text-center',
            data.background_color === 'black' ? 'white' : 'black',
          ]"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="data.title"
        ></h2>
        <ul class="m-0 p-0 bus-models__items">
          <li
            v-for="(item, index) in data?.items"
            :key="index"
            class="bus-models__item"
            data-aos="fade-up"
            :data-aos-delay="index >= 1 ? 100 + 100 * index : 100"
          >
            <NuxtImg
              v-if="item?.image && item?.image?.src"
              :src="item.image.src"
              :alt="item.image.alt"
              :height="item.image.height"
              :width="item.image.width"
              class="bus-models__item-image"
              loading="lazy"
            />
            <div
              v-if="item.title || item.description"
              class="bus-models__item-text"
            >
              <p
                v-if="item.title"
                class="mb-0 bus-models__item-title h3"
                :class="[data.background_color === 'black' ? 'white' : 'black']"
                v-html="item.title"
              ></p>
              <div
                v-if="item.description"
                class="bus-models__item-description body-1-regular"
                :class="[data.background_color === 'black' ? 'white' : 'black']"
                v-html="item.description"
              ></div>
              <Button v-if="item?.url" v-slot="slotProps" as-child rounded>
                <CTagDetect
                  :to="item?.url"
                  :class="[
                    'bus-models__item-button link-normal button-prev-arrow js-button-bus-models',
                    data.background_color === 'black'
                      ? 'button-white'
                      : 'button-black',
                    slotProps.class,
                  ]"
                >
                  <CIcon
                    class="button-prev-arrow__icon"
                    :name="
                      data.background_color === 'black'
                        ? 'arrow-black'
                        : 'arrow-white'
                    "
                    width="16"
                    height="16"
                  />
                  {{ $t('ukravto_group.more_details') }}
                </CTagDetect>
              </Button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<style scoped lang="scss">
.bus-models {
  $parent: &;
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0 auto;
    @include media-breakpoint-up(md) {
      max-width: 66%;
    }
  }
  &__items {
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 0;
    list-style: none;
    @include media-breakpoint-up(sm) {
      gap: 56px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 56);
    }
  }
  &__item {
    border-bottom: 1px solid $divider;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas: 'image' 'text';
    gap: 32px;
    margin: 0;
    padding-bottom: 32px;
    @include media-breakpoint-up(sm) {
      gap: 56px;
      padding-bottom: 56px;
    }
    @include media-breakpoint-up(md) {
      grid-template-columns: 5.45fr 6.55fr;
      gap: 116px;
      grid-template-areas: 'text image';
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-bottom-width, 1);
      @include responsive-spacing(gap, 116);
      @include responsive-spacing(padding-bottom, 56);
    }
    &:last-child {
      border-bottom: unset;
      padding: 0;
    }
    &-image {
      grid-area: image;
      border-radius: 8px;
      height: auto;
      width: 100%;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(border-radius, 8);
      }
    }
    &-text {
      grid-area: text;
      display: flex;
      flex-direction: column;
      gap: 24px;
      @include media-breakpoint-up(sm) {
        gap: 40px;
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(gap, 40);
      }
    }
    &-description {
      &:deep(p:last-child) {
        margin: 0;
      }
    }
    &-button {
      max-width: fit-content;
    }
  }
}
</style>
